import { Component, OnInit } from '@angular/core';
import { HaSurveyserviceService } from '../../services/HaSurvey.service';
import { Router } from '@angular/router';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { CreateSurveyModal } from '../../models/CreateSurvey.model';
import { ErrorModel } from '../../../../shared/models/Error.model';

@Component({
  selector: 'app-ha-surveymanagement-create',
  templateUrl: './ha-surveymanagement-create.component.html',
  styleUrls: ['./ha-surveymanagement-create.component.css']
})

export class HaSurveymanagementCreateComponent implements OnInit {
  questions;
  commonQuestionCount = 0;
  loaderSave: boolean = false;
  commonQuestion;
  surveyDisabled: boolean = false;
  addedList: any[] = [];
  categoryId: string;
  selectedIndex: String = "6";
  headerText: string = "";
  public activeElement1 = 1;
  showOverlaySurveyCreate: boolean;
  noResultFound: boolean;
  activeElementCode = "6";
  elementCommon: HTMLElement;
  surveyData: any[];
  groupVal: string = "";
  mainViewError = new ErrorModel();
  constructor(private router: Router, private _service: HaSurveyserviceService) {}

  ngOnInit() {
    this.surveyDisabled = false;
    this.getAllQuestions();
    // this.getAllHaSurveys();
  }

  getAllQuestions() {
    this.showOverlaySurveyCreate = true;
    this.mainViewError.display = false;
    this._service.getQuestions().subscribe(
    (Data) => {
      this.questions = Data;
      this.commonQuestionCount = this.questions["commonQuestions"] == null ? 0 : this.questions["commonQuestions"].length;
      this.headerText = "International Classification of Diseases : Questions";
      this.commonQuestion = this.questions["commonQuestions"];
      this.getQuestionsModal(this.selectedIndex);
      this.getAllHaSurveys();
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;

    }).add(() => {
      this.showOverlaySurveyCreate = false;
    });
  }


  getAllHaSurveys() {
    this.mainViewError.display = false;
    this._service.getAllHaSurveys().subscribe(
    (data: any[]) => {
      this.surveyData = data;
      // this.getAllQuestions();
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not load all data!', AlertType.Error);
      this.mainViewError.error = error;
      this.mainViewError.display = true;
    });
  }

  //code to get questions based on selected category
  getQuestionsModal(questionSelected) {
    this.elementCommon = document.getElementById("COMMON_Div");
    if (questionSelected == "6") {
      this.activeElementCode = questionSelected;
      this.noResultFound = false;
      this.elementCommon.style.display = "block";
      this.activeElement1 = questionSelected;
      this.headerText = "Common questions";
      this.commonQuestion = this.questions["commonQuestions"];
      if (this.commonQuestion != undefined) {
        if (this.commonQuestion.length <= 0) {
          this.noResultFound = true;
        } else {
          this.noResultFound = false;
        }
      } else {
        this.noResultFound = true;
      }
    }
  }


  storeQuestions(event, id, indexSelected, question) {
    if (indexSelected == '6') {
      if (event.target.checked == true) {
        const addedItem = this.addedList.filter(item => item.id == id)[0];
        if (addedItem !== undefined) {
          const indexOfItem = this.addedList.indexOf(addedItem);
          this.addedList.splice(indexOfItem, 1);
        }
        this.addedList.push({
          "id": id,
          "isEnabled": true,
          "index": 6,
          "questionText": question
        });
        const commonQuestionItem = this.commonQuestion.filter(item => item.id == id)[0];
        if (commonQuestionItem !== undefined) {
          const indexOfCommonItem = this.commonQuestion.indexOf(commonQuestionItem);
          this.commonQuestion[indexOfCommonItem].IsEnabled = true;
        }
      } else {
        const selectedItem = this.addedList.filter(item => item.id == id)[0];
        if (selectedItem !== undefined) {
          const indexOfSelectedItem = this.addedList.indexOf(selectedItem);
          this.addedList.splice(indexOfSelectedItem, 1);
        }
        const selectedCommonItem = this.commonQuestion.filter(item => item.id == id)[0];
        if (selectedCommonItem !== undefined) {
          const indexOfCommonSelectedItem = this.commonQuestion.indexOf(selectedCommonItem);
          this.commonQuestion[indexOfCommonSelectedItem].IsEnabled = false;
        }
      }
    }
  }

  saveSurvey(surveyText) {
    this.surveyDisabled = true;
    if (surveyText == '') {
      this.alertClose();
      AlertMessages.Show('Warning', 'Please enter survey name!', AlertType.Warning);
    } else if (this.addedList.length == 0) {
      this.alertClose();
      AlertMessages.Show('Warning', 'Please select a question for survey!', AlertType.Warning);
    } else {
      const itemMatch = this.surveyData.filter(survey => survey.name.toLowerCase() == surveyText.toLowerCase())[0];
      if (itemMatch !== undefined) {
        this.alertClose();
        AlertMessages.Show('Warning', 'Survey with same name  Already exists!', AlertType.Warning);
      } else {
        this.loaderSave = true;
        let createModal:CreateSurveyModal = new CreateSurveyModal(surveyText,this.addedList);
        this._service.createSurvey(createModal).subscribe(
        (data) => {
          this.alertCloseSurvey();
          AlertMessages.Show('Success', 'Survey Created', AlertType.Success);
        },
        (error) => {
          AlertMessages.Show('Failed', 'Could not save Survey!', AlertType.Error);
          this.loaderSave = false;
        });
      }
    }
  }

  alertCloseSurvey() {
    setTimeout(() => {
      this.loaderSave = false;
      this.surveyDisabled = false;
      this.router.navigate(['Hospital/HAAdmin/HaSurveymain'], {
        queryParams: {}
      });
    }, 1000);
  }

  alertClose() {
    setTimeout(() => {
      this.surveyDisabled = false;
    }, 1000);
  }

  routeToSurveyMain() {
    this.router.navigate(['Hospital/HAAdmin/HaSurveymain'], {
      queryParams: {}
    });
  }

  deleteQuestion(id) {
    if (this.addedList !== undefined && this.addedList !== null && this.addedList.length > 0) {
      AlertMessages.Show('Warning', 'Deletion disabled while question list is not empty', AlertType.Warning);
    } else {
      const response = confirm('Are you sure you want to delete this question?');
      if (response == true) {
        this.categoryId = '6';
        this._service.deleteQuestion(id, this.categoryId).subscribe(
        (data) => {
          this.alertClose();
          AlertMessages.Show('Deleted', 'Deleted Successfully', AlertType.Success);
          this.getAllQuestions();
        },
        (error) => {
          AlertMessages.Show('Failed', 'Could not Delete!', AlertType.Error);

        });
      }
    }
  }

  routeCreateSurvey() {
    this.router.navigate(['Hospital/HAAdmin/CreateSurvey'], {
      queryParams: {}
    });
  }

}
